export default __webpack_public_path__ + "cdd57524db37591a7fd68a3d066a8925.svg";